import React, { useEffect, useState } from "react";

import AdminOverview from "./AdminOverview";
let columns = [
  {
    key: 1,
    label: "",
    id: "action",
    minWidth: 10,
  },
  {
    key: 2,
    label: "Sales Representative",
    id: "full_name",
    width: 200,
    wordBreak: "break-all",
  },
  {
    key: 3,
    label: "Office",
    id: "office_name",
    width: 140,
  },

  {
    key: 5,
    label: "Agents / Properties",
    id1: "agent_count",
    id2: "agent_property_count",
    mergeIds: true,
    alignProp: "center",
  },
  {
    key: 6,
    label: "Email",
    id: "email",
    maxWidth: 240,
    wordWrap: "break-word",
  },
  {
    key: 7,
    label: "Phone number",
    id: "phone",
    width: 180,
  },
  {
    key: 8,
    label: "Website",
    id: "website",
    copyIcon: true,
    alignProp: "left",
  },
];

const SalesRepresentativesTab = ({
  base_route,
  isRepInAdmin = false,
  isSuperAdmin = false,
  broker_data = {},
}) => {
  console.log("base_route==> ", base_route);
  const [sm_tabData, setSM_tabData] = useState({
    sm_columns: columns,
    sm_btn_texts: "Add sales representative",
  });

  useEffect(() => {
    if (isRepInAdmin) {
      if (!columns.find((e) => e.key === 4)) {
        columns.push({
          key: 4,
          label: "Sales Manager",
          id: "sales_manager_name",
        });
      }
      // columns.forEach((col) => {
      //   if (col.id === "website") {
      //     col.copyIcon = true;
      //     col.alignProp = "center";
      //   }
      // });
      if (isSuperAdmin) {
        columns.forEach((col) => {
          if (col.key === 1) {
            col.id = "sr";
            col.label = "No.";
          }
        });
        if (!columns.find((e) => e.key === 9)) {
          columns.push({
            key: 9,
            label: "Action",
            id: "action",
            minWidth: 10,
          });
        }
      }
      columns.sort(function (a, b) {
        return a.key - b.key;
      });
      setSM_tabData((prevState) => ({ ...prevState, sm_columns: columns }));
    } else {
      // columns.forEach((col) => {
      //   if (col.id === "website") {
      //     col.copyIcon = false;
      //     col.alignProp = "left";
      //   }
      // });

      setSM_tabData((prevState) => ({ ...prevState, sm_columns: columns }));
    }
  }, [isRepInAdmin]);

  return (
    <div>
      <AdminOverview
        base_route={base_route}
        sm_tabData={sm_tabData}
        isSalesManager={true}
        isRepInAdmin={isRepInAdmin}
        isSuperAdmin={isSuperAdmin}
        broker_data={broker_data}
      />
    </div>
  );
};

export default SalesRepresentativesTab;
